/* hide-card-tax-home.js
   Entfernt das vom B2B-Preis-App injizierte Steuerlabel
   ("inkl. MwSt." / "inc. VAT") aus den Produktkarten-Preisen.
   Nur auf der Startseite (template-index). */
(function () {
  'use strict';
  if (!/(^|\s)template-index(\s|$)/.test(document.body.className)) return;

  var LABEL = /\s*(?:inkl\.?\s*MwSt\.?|inkl\.?\s*Mehrwertsteuer|incl?\.?\s*VAT)\s*/i;

  function strip(root) {
    (root || document).querySelectorAll('product-card .price, .product-card .price').forEach(function (price) {
      [price].concat([].slice.call(price.querySelectorAll('*'))).forEach(function (el) {
        el.childNodes.forEach(function (n) {
          if (n.nodeType === 3 && LABEL.test(n.nodeValue)) {
            n.nodeValue = n.nodeValue.replace(new RegExp(LABEL.source, 'gi'), '');
          }
        });
      });
    });
  }

  function run() { try { strip(document); } catch (e) {} }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // Das App rendert Preise teils nach, daher beobachten (entprellt).
  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(run, 60);
  }).observe(document.body, { childList: true, subtree: true });
})();
